export const usersColumns = [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
  { id: 'nombre', label: 'Nombre', type: 'text', required: true },
  { id: 'correo', label: 'Correo', type: 'email', required: true },
  { id: 'contrasena', label: 'Contraseña', type: 'password', required: true, onlyOnCreate: true },
  { id: 'contrasena2', label: 'Repetir Contraseña', type: 'password', required: true, onlyOnCreate: true },
  { id: 'cedula', label: 'Cédula', type: 'text', required: true },
  {
    id: 'rol',
    label: 'Rol',
    type: 'select',
    required: true,
    options: [
      { value: 'admin', label: 'Administrador' },
      { value: 'operador', label: 'Operario' },
      { value: 'supervisor', label: 'Supervisor' },
      { value: 'asesor', label: 'Asesor' },
      { value: 'cliente', label: 'Cliente' },
      { value: 'planta', label: 'Planta' },
      { value: 'documentacion', label: 'Documentación' },
    ],
  },
  {
    id: 'planta',
    label: 'Planta',
    type: 'asyncSelect',
    required: true,
    fetchOptions: async () => {
      try {
        const { plantasService } = await import('@/pages/parametrizacion/plantas/utils/plantasService');
        const response = await plantasService.getAll();
        const plantas = response?.data || [];
        return plantas.map((p) => ({ value: { id: p._id, nombre: p.nombre }, label: p.nombre }));
      } catch (e) {
        console.error('Error cargando opciones de plantas', e);
        return [];
      }
    },
  },
];

export const columnsExcel = [
  { key: 'estado', header: 'Estado' },
  { key: 'nombre', header: 'Nombre' },
  { key: 'correo', header: 'Correo' },
  { key: 'rol', header: 'Rol' },
  { key: 'lavanderia.nombre', header: 'Centro de Lavado' },
];
